/**
 * @generated SignedSource<<14a9c568fc3ada6f7ccd7f094145e294>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type UserCellInternal$data = {
  readonly fieldId: string;
  readonly type: string;
  readonly user: {
    readonly accountId: string;
    readonly name: string;
    readonly picture: AGG$URL;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"UserCellInternal_UserCellInternal">;
  readonly " $fragmentType": "UserCellInternal";
};
export type UserCellInternal$key = {
  readonly " $data"?: UserCellInternal$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserCellInternal">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isEditableSyncLoaded"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isInlineEditingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "UserCellInternal",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "fieldId"
    },
    {
      "kind": "ScalarField",
      "name": "type"
    },
    {
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "accountId"
        },
        {
          "kind": "ScalarField",
          "name": "picture"
        },
        {
          "kind": "ScalarField",
          "name": "name"
        }
      ]
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isEditableSyncLoaded",
          "variableName": "isEditableSyncLoaded"
        },
        {
          "kind": "Variable",
          "name": "isInlineEditingEnabled",
          "variableName": "isInlineEditingEnabled"
        }
      ],
      "kind": "FragmentSpread",
      "name": "UserCellInternal_UserCellInternal"
    }
  ],
  "type": "JiraSingleSelectUserPickerField"
};

(node as any).hash = "dfe84aeaa30deeba2aa3f610e9df2d11";

export default node;
